<mat-icon (click)="close()">close</mat-icon>
<img src="assets/imgs/login_popup.jpg" (click)="login()">


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/event.details/login.with.facebook.modal/login.with.facebook.modal.html